import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be49476a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "s-modal"
}
const _hoisted_2 = { class: "modal-frame middle" }
const _hoisted_3 = { class: "search-results report" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "order" }, "表示順"),
    /*#__PURE__*/_createElementVNode("th", { class: "value" }, "項目名"),
    /*#__PURE__*/_createElementVNode("th", { class: "action" }, "アクション")
  ])
], -1))
const _hoisted_5 = { class: "order" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "handle" }, null, -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "action buttons" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "value" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "action buttons" }
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "actions" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_18 = { class: "board-buttons -under" }
const _hoisted_19 = ["disabled"]

import { computed, ref, watch, withDefaults } from 'vue';
import { PulldownList, PulldownListRow, isValidPCcontents, addEditRow, isValidEditRows, save, load } from '@/utility/PulldownList';
import { validClass } from '@/utility/valid';
import InputSelect from '@/components/InputSelect.vue';
import draggable from 'vuedraggable';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputListEdit',
  props: {
    val: null,
    list: null,
    placeholder: { default: '選択して下さい' },
    disabled: { type: Boolean },
    class: { default: '' }
  },
  emits: ["update:val", "update:list", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:val', value: string): void;
  (e: 'update:list', value: PulldownList): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { val: string, list: PulldownList, placeholder: string, disabled?: boolean, class: string }




//  selected string
const inputText = ref('');
watch(inputText, setModel);
function setModel() {
  modelVal.value = inputText.value;
}

const modelVal = computed({
  get: () => props.val,
  set: value => emit('update:val', value),
});

watch(() => props.val, initInputText);
function initInputText() {
  inputText.value = String(modelVal.value);
}

//  list
const editRows = ref<PulldownListRow[]>([]);
const selectList = computed(() => editRows.value.map(row => row.pCcontents));

const modelList = computed({
  get: () => props.list,
  set: value => emit('update:list', value),
});

watch(() => props.list, initList);
function initList() {
  editRows.value = [...modelList.value.rows];
  editRows.value.forEach((_, i) => (editRows.value[i].pNo = i + 1));
}

async function onOkButton() {
  editRows.value.forEach((_, i) => (editRows.value[i].pNo = i + 1));
  await save(modelList.value, editRows.value);
  const list = await load(modelList.value.pId);
  modelList.value.rows = [...list.rows];

  isDispSetting.value = false;
}

//  display dialog
const isDispSetting = ref(false);

function init() {
  initInputText();
  initList();
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InputSelect, {
      modelValue: inputText.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event)),
      class: _normalizeClass(props.class),
      disabled: props.disabled,
      list: _unref(selectList),
      placeholder: props.placeholder,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change')))
    }, null, 8, ["modelValue", "class", "disabled", "list", "placeholder"]),
    _createElementVNode("button", {
      class: "btn-small setting",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (isDispSetting.value = true))
    }),
    (isDispSetting.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, "プルダウンリスト " + _toDisplayString(_unref(modelList).pName) + " の編集", 1),
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_3, [
                _hoisted_4,
                _createVNode(_unref(draggable), {
                  modelValue: editRows.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editRows).value = $event)),
                  animation: 200,
                  handle: ".handle",
                  "item-key": "pNo",
                  tag: "tbody"
                }, {
                  item: _withCtx(({ element, index }) => [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("input", {
                          type: "text",
                          value: index + 1,
                          disabled: ""
                        }, null, 8, _hoisted_7)
                      ]),
                      (element.editStatus === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("td", _hoisted_8, _toDisplayString(element.pCcontents), 1),
                            _createElementVNode("td", _hoisted_9, [
                              _createElementVNode("button", {
                                class: "btn-small",
                                onClick: ($event: any) => (element.editStatus = 1)
                              }, "編集", 8, _hoisted_10)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("td", _hoisted_11, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((element.pCcontents) = $event),
                                type: "text",
                                class: _normalizeClass(_unref(validClass)(_unref(isValidPCcontents)(element.pCcontents)))
                              }, null, 10, _hoisted_12), [
                                [_vModelText, element.pCcontents]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_13, [
                              _createElementVNode("button", {
                                class: "btn-small",
                                onClick: ($event: any) => (element.editStatus = 0),
                                disabled: !_unref(isValidPCcontents)(element.pCcontents)
                              }, " 適用 ", 8, _hoisted_14),
                              _createElementVNode("button", {
                                class: "btn-small",
                                onClick: ($event: any) => (editRows.value = editRows.value.filter(v => v.no != element.no))
                              }, "削除", 8, _hoisted_15)
                            ])
                          ], 64))
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("button", {
                  class: "btn-small add",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(addEditRow)(editRows.value)))
                }, "追加")
              ])
            ]),
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  onClick: onOkButton,
                  disabled: !_unref(isValidEditRows)(editRows.value)
                }, "保存", 8, _hoisted_19)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (isDispSetting.value = false))
                }, "キャンセル")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})